module.exports = __webpack_public_path__ + "static/media/01-dribbble.4dd6575c.svg";